import StepMobile from './stepMobile/stepMobile.component';
import StepOtp from './stepOtp/stepOtp.component';
import StepUser from './stepUser/stepUser.component';

export { StepOtp, StepMobile, StepUser };
